import { render, staticRenderFns } from "./permissionList.vue?vue&type=template&id=f8cafe20&scoped=true&"
import script from "./permissionList.vue?vue&type=script&lang=js&"
export * from "./permissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8cafe20",
  null
  
)

export default component.exports